module.exports = __webpack_public_path__ + "static/media/emptybag.114f2763.jpg";